const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#FFFCF9]" data-testid="privacy-page">
      {/* Hero */}
      <section className="py-20 bg-spa-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-heading text-5xl md:text-6xl text-spa-neutral-800 mb-6">
              Privacy Policy
            </h1>
            <p className="text-spa-neutral-500 text-lg">Last updated: January 2025</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl spa-shadow p-8 md:p-12">
            <div className="space-y-8">
              {[
                { title: "1. Information We Collect", content: "When you book an appointment or contact us, we may collect your full name, phone number, email address (optional), appointment preferences and history, and any health information you voluntarily provide for treatment purposes." },
                { title: "2. How We Use Your Information", content: "We use your personal information to process and manage your bookings, communicate with you about your appointments, provide personalized treatments based on your preferences, send appointment reminders via WhatsApp, and improve our services." },
                { title: "3. Information Protection", content: "We are committed to protecting your personal information. We implement appropriate security measures to prevent unauthorized access, disclosure, or misuse of your data. Your information is stored securely and only accessed by authorized personnel." },
                { title: "4. Information Sharing", content: "We do not sell, trade, or rent your personal information to third parties. We may share information only with your explicit consent, to comply with legal obligations, or to protect our rights and safety." },
                { title: "5. Your Rights", content: "You have the right to access your personal information, request correction of inaccurate data, request deletion of your data, and opt out of marketing communications." },
                { title: "6. WhatsApp Communication", content: "By providing your phone number and booking through our platform, you consent to receiving appointment-related communications via WhatsApp. This includes booking confirmations, reminders, and service updates." },
                { title: "7. Cookies & Website Data", content: "Our website may use cookies to enhance your browsing experience. These cookies help us understand how you use our website and improve our services." },
                { title: "8. Changes to This Policy", content: "We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date." },
              ].map((section) => (
                <div key={section.title}>
                  <h2 className="font-heading text-2xl font-semibold text-spa-neutral-800 mb-4">{section.title}</h2>
                  <p className="text-spa-neutral-600 leading-relaxed">{section.content}</p>
                </div>
              ))}

              <div>
                <h2 className="font-heading text-2xl font-semibold text-spa-neutral-800 mb-4">9. Contact Us</h2>
                <p className="text-spa-neutral-600 leading-relaxed mb-4">If you have any questions about this privacy policy, please contact us:</p>
                <ul className="text-spa-neutral-600 space-y-2">
                  <li>Phone: 065 902 9122</li>
                  <li>Email: krielcolonandbeautyspa@gmail.com</li>
                  <li>Address: 32 Kraanvoel Avenue, Kriel</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
